import { MessageCircle } from 'lucide-react';
import { useCart } from '@/context/CartContext';

export function WhatsAppButton() {
  const { cartItems, cartTotal } = useCart();

  const generateWhatsAppMessage = () => {
    if (cartItems.length === 0) {
      return encodeURIComponent("Hi! I want to order from QUICK GRAM TURA.");
    }
    
    let message = "Hi! I want to place an order:\n\n";
    cartItems.forEach((item, index) => {
      message += `${index + 1}. ${item.name} (${item.unit}) x ${item.quantity} = ₹${(item.price * item.quantity).toFixed(0)}\n`;
    });
    message += `\n*Total: ₹${cartTotal.toFixed(0)}*\n\nPlease confirm my order.`;
    
    return encodeURIComponent(message);
  };

  const whatsappNumber = "919603540072";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${generateWhatsAppMessage()}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-button"
      aria-label="Order via WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
}
